<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/rurs@2x.webp 2x, {CDN_URL}/ventures/rurs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/rurs@2x.png 2x, {CDN_URL}/ventures/rurs.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/75369203/RURS-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/79115527/RURS-UIUX-Design" :title="$t('cta2')" class="button-link  " v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"RURS",
    "pageDesc":"RURS is Baianat digital marketing platform that provides marketers with resources and guides that helps them walk on an authentic process.",
    "mantra":"RURS marketing |platform.",
    "content":"<p>Marketing is one of the fields where there are many approaches and ways exists. In our process of standardizing the marketing approach, we faced a lot of challenges. From finding the right process to finding a suitable template to contain our ideas. And with many marketing channels, it was a little bit of hassle trying to connect them all together.</p><p>And because we faced this issue, we were wondering how many marketing teams around the world are suffering from the same headache. This is when the idea of RURS came up. We wanted to create a platform that empowers marketers all over the world with authentic materials that helps them focus on innovation and worry less about documentation.</p><p>In addition, we wanted to prove that a science like marketing can have standards and be documented in an approach that yields the same results.</p><p>So we planned RURS to provide marketers with a place to start from. So all they have to do is drag and drop the elements needed, then answer a few questions and extract the project template shared with the client directly. This checklist concept makes it easier to grow through the marketing process without missing any steps. RURS will contain guides, ebooks and articles on how to best utilize the marketing powers to in supporting business goals.</p><p>The platform brand identity and UI/UX design was made to match the industry of marketing and you can check it on Behance</p>",
    "cta":"Brand identity",
    "cta2":"UI/UX design"
  },
  "ar": {
    "pageTitle":"رورز",
    "pageDesc":"رورز منصة التسويق الرقمي الخاصة ببيانات التي تزود المسوقين بالمصادر والأدلة التي تساعدهم على أداء أعمالهم بشكل احترافي.",
    "mantra":"روزر منصة |التسويق.",
    "content":"<p>التسويق هو أحد المجالات التي لديها طرق مختلفة ومناهج متعددة للعمل وتحقيق الهدف النهائي. وفي طريقنا من أجل إيجاد منهج موحد للعمل به، واجهنا الكثير من التحديات. بداية من العثور على العملية الصحيحة حتى إيجاد قالب مناسب يمكننا من خلاله ترتيب أفكارنا. ومع وجود العديد من القنوات التسويقية، كان هناك القليل من المتاعب من أجل توصيلهم سويًا. </p><p>لأننا واجهنا هذه المشكلات، سألنا أنفسنا عن عدد فرق التسويق حول العالم الذين يعانون من نفس المشكلة. ومن هنا جاءتني فكرة رورز. أردنا إنشاء منصة تمد المسوقين في جميع أنحاء العالم بمواد تساعدهم على الابتكار والتركيز على أعمالهم بدلًا من القلق بشأن الوثائق و الملفات. </p><p>بالإضافة إلى ذلك، أردنا أن نثبت أن علم التسويق يمكن أن يكون له مبادئ ومعايير محددة وأن يتم توثيقة بطريقة تحقق نفس النتائج. </p><p>لهذا السبب أنشأنا رورز لتزويد المسوقين بمنصة يمكنهم البدء من خلالها. لذلك كل ما عليهم هو سحب وإسقاط العناصر اللازمة، ثم الإجابة على بعض الأسئلة اللازمة واستخراج قالب المشروع الذي يمكن مشاركته مع العميل. يُسهل مفهوم القوائم عملية النمو دون فقدان أي خطوة. سوف يحتوى رورز على أدلة وكتب إلكترونية ومقالات حول أفضل طريقة لاستخدام قوى التسويق في دعم أهداف العمل. </p><p>تم تصميم هوية العلامة التجارية وكذلك تصميم تجربة المستخدم وواجهة المستخدم لتتناسب مع صناعة التسويق ويمكنك مشاهدة ذلك على بيهانس.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم واجهة المستخدم / تجربة المستخدم"
  }
}
</i18n>
